module.exports = __webpack_public_path__ + "img/contact.dcd579d0.png";